import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Muhammad Noman"))
    BasePath.set("/Portfolio/")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { noman.pages.HomePage() }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("headline-text", noman.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", noman.SubheadlineTextStyle)
        ctx.theme.registerStyle("about", noman.components.sections.about.style.AboutStyle)
        ctx.theme.registerStyle("skills-section",
                noman.components.sections.about.style.SkillsSectionStyle)
        ctx.theme.registerStyle("skills-grid",
                noman.components.sections.about.style.SkillsGridStyle)
        ctx.theme.registerStyle("about-discription",
                noman.components.sections.about.style.AboutDiscriptionStyle)
        ctx.theme.registerStyle("footer", noman.components.sections.footer.style.FooterStyle)
        ctx.theme.registerStyle("footer-text",
                noman.components.sections.footer.style.FooterTextStyle)
        ctx.theme.registerStyle("footer-location",
                noman.components.sections.footer.style.FooterLocationStyle)
        ctx.theme.registerStyle("footer-description",
                noman.components.sections.footer.style.FooterDescriptionStyle)
        ctx.theme.registerStyle("hero-section",
                noman.components.sections.home.style.HeroSectionStyle)
        ctx.theme.registerStyle("hello-im", noman.components.sections.home.style.HelloImStyle)
        ctx.theme.registerStyle("user-name", noman.components.sections.home.style.UserNameStyle)
        ctx.theme.registerStyle("users-message",
                noman.components.sections.home.style.UsersMessageStyle)
        ctx.theme.registerStyle("nav-header",
                noman.components.sections.navHeader.styles.NavHeaderStyle)
        ctx.theme.registerStyle("side-menu",
                noman.components.sections.navHeader.styles.SideMenuStyle)
        ctx.theme.registerStyle("menu", noman.components.sections.navHeader.styles.MenuStyle)
        ctx.theme.registerStyle("projects", noman.components.sections.projects.style.ProjectsStyle)
        ctx.theme.registerStyle("section-title", noman.components.SectionTitleStyle)
        ctx.theme.registerStyle("section-discription", noman.components.SectionDiscriptionStyle)
        ctx.theme.registerStyle("skill-text", noman.components.styles.SkillTextStyle)
        ctx.theme.registerStyle("skill-proficiency-text",
                noman.components.styles.SkillProficiencyTextStyle)
        ctx.theme.registerStyle("main-button", noman.components.styles.MainButtonStyle)
        ctx.theme.registerStyle("section-container", noman.components.styles.SectionContainerStyle)
        ctx.theme.registerStyle("social-link", noman.components.styles.SocialLinkStyle)
        ctx.theme.registerVariant("-circle", noman.CircleButtonVariant
        )
        ctx.theme.registerVariant("-uncolored", noman.UncoloredButtonVariant
        )
        ctx.theme.registerVariant("-skill-item",
                noman.components.sections.about.style.SkillItemImageVariant
        )
        ctx.theme.registerVariant("-normal", noman.components.styles.ButtonColors.NormalButton
        )
        ctx.theme.registerKeyframes("hero-container-key-frames",
                noman.components.sections.home.style.HeroContainerKeyFrames)
        ctx.theme.registerKeyframes("side-menu-slide-in",
                noman.components.sections.navHeader.styles.SideMenuSlideInAnim)
        noman.initColorMode(ctx)
        noman.initSiteStyles(ctx)
        noman.initTheme(ctx)
    }

    router.tryRoutingTo(BasePath.remove(window.location.href.removePrefix(window.origin)),
            UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        noman.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
